<form id="clientEditForm" [formGroup]="clientEditForm!" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="name" class="control-label required">{{'i18n.shared.fields.name' | translate}}</label>
      <input id="name" name="name" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="clientEditForm!.controls.name"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="address" class="control-label">{{'i18n.shared.fields.address' | translate}}</label>
      <input id="address" name="address" type="text" class="form-control" formControlName="address" />
      <app-error-messages [control]="clientEditForm!.controls.address"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="zip" class="control-label">{{'i18n.shared.fields.zip' | translate}}</label>
      <input id="zip" name="zip" type="text" class="form-control" formControlName="zip" />
      <app-error-messages [control]="clientEditForm!.controls.zip"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="city" class="control-label">{{'i18n.shared.fields.city' | translate}}</label>
      <input id="city" name="city" type="text" class="form-control" formControlName="city" />
      <app-error-messages [control]="clientEditForm!.controls.city"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="email" class="control-label">{{'i18n.shared.fields.email' | translate}}</label>
      <input id="email" name="email" type="email" class="form-control" formControlName="email" />
      <app-error-messages [control]="clientEditForm!.controls.email"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="phoneNumber" class="control-label">{{'i18n.shared.fields.phone' | translate}}</label>
      <input id="phoneNumber" name="phoneNumber" type="text" class="form-control" formControlName="phoneNumber" />
      <app-error-messages [control]="clientEditForm!.controls.phoneNumber"></app-error-messages>
    </div>
  </div>
  @if (isEdit) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
        <app-yes-no-group-button id="isActive" formControlName="isActive"></app-yes-no-group-button>
      </div>
    </div>
  }
</form>
